import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

/**
 * Directiva *appNgVar para asignar una variable en el template.
 * Uso: <ng-container *appNgVar="expression as varName">
 */
@Directive({
  selector: '[appNgVar]'
})
export class NgVarDirective<T = unknown> {
  private context: NgVarContext<T> = { appNgVar: null, $implicit: null };
  private hasView = false;

  constructor(
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<NgVarContext<T>>
  ) {}

  @Input()
  set appNgVar(value: T) {
    this.context.$implicit = this.context.appNgVar = value;
    if (!this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef, this.context);
      this.hasView = true;
    }
  }

  static ngTemplateContextGuard<T>(
    dir: NgVarDirective<T>,
    ctx: any
  ): ctx is NgVarContext<T> {
    return true;
  }
}

interface NgVarContext<T> {
  appNgVar: T | null;
  $implicit: T | null;
}
